import React, {Component} from 'react';
import * as version from "./utils/.env";

class Footer extends Component {

	render() {
		return (
			<footer id="footer">
				<span title={version.buildTime}>&copy; 2017, 2021 Český svaz biatlonu</span>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/Footer.js